module.exports = new __parcel__URL__("Vania.8579933b.svg").toString();